export const formatLeadPhone = (value) => {
  if (!value) return '-';

  const original = String(value).trim();
  const digits = original.replace(/\D/g, '');
  const nationalNumber = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;

  if (nationalNumber.length !== 10) return original;
  return `+1 ${nationalNumber.slice(0, 3)}-${nationalNumber.slice(3, 6)}-${nationalNumber.slice(6)}`;
};
